import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import ManageInstitutions from '../views/Home/ManageInstitutions.vue'
import CampusList from '../views/Home/campusList.vue'
import Authorized from '../views/Authorized.vue'
import Inform from '../views/Course/inform.vue'
import CourseList from '../views/Course/courseList'
import ActivityList from '../views/Course/activityList'
import Students from '../views/Course/students'
import StuList from '../views/Course/stuList'
import PayMobile from '../views/payMobile.vue'
import ReceiveCoupon from '../views/receiveCoupon.vue'
import Mine from '../views/Mine/mine.vue'
import MineDiscount from '../views/Mine/mineDiscount.vue'
import { postLoginAPI } from "../utils/api/api";
import {baseURL,urlAuth} from '../utils/request'
import {common} from '../utils/common.js'


Vue.use(VueRouter)

  const routes = [
    // 登录  
  {
    path: '/',
    redirect: '/mine'
  },
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  
  // 领取现金券
  {
    path: '/receiveCoupon',
    name: 'ReceiveCoupon',
    component: ReceiveCoupon,
    meta: {
      title: '领取现金券'
    }
  },
  // 我的
  {
    path: '/mine',
    name: 'Mine',
    component: Mine,
    meta: {
      title: '我的'
    }
  },
  // 我的优惠券
  {
    path: '/mineDiscount',
    name: 'MineDiscount',
    component: MineDiscount,
    meta: {
      title: '我的优惠券'
    }
  },
  // 管辖机构
  {
    path: '/manageInstitutions',
    name: 'ManageInstitutions',
    component: ManageInstitutions,
    meta: {
      title: '管辖机构'
    }
  },
  // 校区列表
  {
    path: '/campusList',
    name: 'CampusList',
    component: CampusList,
    meta: {
      title: '校区列表'
    }
  },
  // 我的  
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      title: '我的主页'
    }
  },
  //  授权
  {
    path:'/authorized',
    name:'Authorized',
    component: Authorized,
    meta: {
      title: '授权'
    }
  },
  // 通知
  {
    path:'/inform',
    name:'Inform',
    component: Inform,
    meta: {
      title: '通知'
    }
  },
  // 课表
  {
    path: '/courseList',
    name: 'CourseList',
    component: CourseList,
    meta: {
      title: '课表'
    }
  },
  // 课程学员
  {
    path: '/stuList',
    name: 'StuList',
    component: StuList,
    meta: {
      title: '学员'
    }
  },
  // 活动
  {
    path: '/activityList',
    name: 'ActivityList',
    component: ActivityList,
    meta: {
      title: '活动'
    }
  },
  // 活动学员
  {
    path: '/students',
    name: 'Students',
    component: Students,
    meta: {
      title: '学员'
    }
  },
  // 支付
  {
    path: '/payMobile',
    name: 'PayMobile',
    component: PayMobile,
    meta: {
      title: '支付学费-旭课支付'
    }
  },
]

const router = new VueRouter({
  routes
})

var flag = false
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  console.log('flag:',flag)
  console.log('path:',to,to.path)
  console.log('path1:',to.path.search('/payMobile'))
  if(to.path.search('/payMobile') != -1 || (to.path.search('/ti/wx/institution/userinfo/institution') != -1 && flag)){
    flag = true
    document.title = '支付学费-旭课支付'
    var ua = window.navigator.userAgent.toLowerCase();
    //判断是不是微信
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      console.log('进入微信')
      // return "WeiXIN";
      window.localStorage.setItem('payChannel',"W1")
      var openidStr = ""
      if( window.localStorage.getItem('Payopenid')){
        openidStr = window.localStorage.getItem('Payopenid');
      }else{
        var localStorageHref = location.href
        if(to.query.openid){
          openidStr = to.query.openid;
        }else if(localStorageHref.search('openid=') != -1) {
          openidStr = localStorageHref.split('openid=')[1]
        }
      }
      // alert("微信"+openidStr+"/"+to.query.openid)
      // 目前写死，将来可能会更改
      var publicAccountType = "institution";
      if (openidStr &&openidStr!="undefined" && openidStr!=null&&typeof(openidStr)!="undefined") {
        console.log('111:',openidStr)
        // alert('带参：'+JSON.stringify(to.query))
        // window.localStorage.setItem('PayPublicAccountType',publicAccountType)
        window.localStorage.setItem('Payopenid',openidStr)
        if(to.query.institutionCode){
          window.localStorage.setItem('institutionCode',to.query.institutionCode)
        }
        if(to.query.institutionName){
          window.localStorage.setItem('institutionName',decodeURIComponent(to.query.institutionName))
        }
        flag = false
        next()
      
      }
      if (!openidStr || openidStr=="undefined" || openidStr==null || typeof(openidStr)=="undefined") {
        // alert('rttt')
        console.log('333:',openidStr)
        // openidStr = window.localStorage.getItem('Payopenid');
        // publicAccountType = window.localStorage.getItem('PayPublicAccountType');
        // location.href="http://192.168.1.139:8081"+"/#/index";
        var href = location.href
        const redirect_url=encodeURIComponent(href);
        // alert("location.href:"+location.href+'query:'+JSON.stringify(to.query))
        // alert('redirect_url:'+redirect_url)
        location.href=baseURL+"/ti/wx/institution/userinfo/institution?scope=snsapi_base&state="+redirect_url;
        // alert(456)
        // alert(publicAccountType)
        // alert(location.href)
        // alert(openidStr)
      }
    }
    //判断是不是支付宝
    if (ua.match(/AlipayClient/i) == "alipayclient") {
      alert("阿里")
      var userId = ""
      if(window.localStorage.getItem("payUserId")){
        userId = window.localStorage.getItem("payUserId")
      }
      if(!userId || userId =="undefined" || userId == null || typeof(userId)=="undefined"){
        alert('没有userid调阿里的方法')
        ap.getAuthCode ({
          appId :  '2021002117694587' ,
          scopes : [ 'auth_base' ],
       },  function ( res ){
         alert("阿里用户信息"+JSON.stringify(res))
         console.log("阿里用户信息",res)
          ap.alert ( JSON.stringify ( res ));
       });
      }
      if(userId && userId != "undefined" && userId != null && typeof(userId)!='undefined'){
        alert("userId"+userId)
        window.localStorage.setItem("payUserId",userId)
        if(to.query.institutionCode){
          window.localStorage.setItem('institutionCode',to.query.institutionCode)
        }
        if(to.query.institutionName){
          window.localStorage.setItem('institutionName',to.query.institutionName)
        }
        next()
      }
    }
  }else{ 
    // 目前有用的页面只有登录，我的，领取优惠券，我的优惠券列表
        const redirect_url=encodeURIComponent(location.href);
        var openidStr = ''
        var publicAccountType = ''
        var tokenStr = ''
        if(to.query.openid) {
            openidStr = to.query.openid;
            common.setCache('openid',openidStr)
        }else if(common.getCache('openid')) {
            openidStr = common.getCache('openid')
        }
        if(to.query.publicAccountType) {
            publicAccountType = to.query.publicAccountType
            common.setCache('publicAccountType',publicAccountType)
        }else if(common.getCache('publicAccountType')) {
            publicAccountType = common.getCache('publicAccountType')
        }
        if(common.getCache('token')) {
            tokenStr = common.getCache('token')
        } 
        // 是否由登录页面跳转过来
        console.log('---openidStr,publicAccountType,tokenStr', openidStr, publicAccountType, tokenStr)
        if(!openidStr) {
            console.log('进入重定向')
            // alert("openidStr不存在，跳转获取openid接口");
            location.href=baseURL+"/ti/wx/institution/userinfo/"+urlAuth+"?scope=snsapi_base&state="+redirect_url;
        }
        // else if(to.path == '/receiveCoupon') {
        //     next()
        // }
        else if(to.path == '/login'){
            console.log('进入登录页面')
            postLoginAPI({
                loginMode: 2,
                productId: 1,
                clientId: '1004',
                thirdUniqueId: openidStr,
            }).then(res => {
                console.log('路由拦截中的登录：', res)
                if(res.resultCode == 200) {
                    common.setCache('tokenCreateTime', new Date().getTime())
                    common.setCache('token',res.data.token)
                    common.setCache('customerInfo',JSON.stringify(res.data))
                    next('/mine')
                }else {
                    common.removeCache('token')
                    common.removeCache('customerInfo')
                    common.removeCache('tokenCreateTime')
                    next()
                }
                
            })
        }else {
            console.log('进入非登录页面：', to.path)
            if(openidStr && publicAccountType && tokenStr && common.getCache('customerInfo')) {
                next()
            }else {
                postLoginAPI({
                    loginMode: 2,
                    productId: 1,
                    clientId: '1004',
                    thirdUniqueId: openidStr,
                }).then(res => {
                    console.log('路由拦截中的登录1：', res)
                    if(res.resultCode == 200) {
                        common.setCache('tokenCreateTime', new Date().getTime())
                        common.setCache('token',res.data.token)
                        common.setCache('customerInfo',JSON.stringify(res.data))
                        next()
                    }else {
                        common.removeCache('token')
                        common.removeCache('customerInfo')
                        common.removeCache('tokenCreateTime')
                        if(to.path == '/receiveCoupon') {
                            next()
                        }else {
                            next('/login')
                        }
                        
                    }
                    
                })
            }
        }
  }
})


export default router
